import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Moment from 'moment';
import { toast } from 'react-toastify';

import ServiceSubs from 'services/serviceSubs';

export default function ComponentExpiredSubList(props) {

    const [records, setRecords] = useState([]);

    const [filter, setFilter] = useState({ 'endDate': { $lt: new Date() } });
    const [query, setQuery] = useState('');

    const [pageSize, setPageSize] = useState(10);
    const [pageCurrent, setPageCurrent] = useState(0);
    const [pageTotal, setPageTotal] = useState(0);

    const navigate = useNavigate();
    const subsService = new ServiceSubs();

    const gotoOrgInfo = (id) => {
        navigate(`/orgInfo/${id}`);
    }

    const loadData = () => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 1,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": "",
                "endDate": ""
            };
            var res = await subsService.getAllSubs(body, '');
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="col-span-12 cursor-pointer">
            <div className="shadow bg-white rounded-lg p-4">
                <h3 className='text-lg font-sans font-medium'>{props.title} | Top 10</h3>
                <hr className='my-2' />
                <table className="min-w-full divide-y divide-gray-200 px-4">
                    <thead className="bg-gray-50">
                        <tr>
                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                ORG ID
                            </th>
                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                SUB ID
                            </th>
                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                ORG Name
                            </th>
                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Email ID
                            </th>
                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Phone Number
                            </th>
                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Main Code
                            </th>
                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Status
                            </th>
                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Expired At
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {
                            records.length !== 0 && records.map((record) => {
                                return <tr className="hover:bg-gray-100" key={record._id}>
                                    <td className="px-4 py-4 whitespace-nowrap cursor-pointer" onClick={() => { gotoOrgInfo(record.ordid.ordid); }}>
                                        <div className="text-sm font-bold text-gray-900">
                                            <div className='flex items-center text-prime'>
                                                #{record.ordid.ordid}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-4 py-4 whitespace-nowrap cursor-pointer">
                                        <div className="text-sm font-bold text-gray-900">
                                            <div className='flex items-center text-prime'>
                                                #{record.subid}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <div className="text-sm font-bold text-gray-900 uppercase flex items-center">
                                            <img src={record.ordid.profile_media.fileurl} alt='logo image' className='w-10 h-10 rounded' />
                                            <span className='ml-2'>{record.ordid.name}</span>
                                        </div>
                                    </td>
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <div className="text-sm font-bold text-gray-900">
                                            {record.ordid.email}
                                        </div>
                                    </td>
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <div className="text-sm font-bold text-gray-900">
                                            +91 {record.ordid.phone}
                                        </div>
                                    </td>
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <div className="text-sm text-prime">
                                            {record.ordid.settings.maincode}
                                        </div>
                                    </td>
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${record.status == 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                            {record.status.toUpperCase()}
                                        </span>
                                    </td>
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <div className="text-sm font-bold text-gray-900">
                                            {Moment(record.endDate).format('DD MMM, yyyy hh:mm:ss A')}
                                        </div>
                                    </td>
                                </tr>
                            })
                        }
                        {
                            records.length === 0 && <tr className="cursor-pointer hover:bg-gray-100">
                                <td className="px-6 py-4 whitespace-nowrap" colSpan="8">
                                    <div className="text-sm text-red-600 text-center">
                                        No data found.
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}
